<div class="row">
<div labelTextInput class="col-sm-12 bloccodati" [typeLabel]="'text'"
	[labelInput]="'Tipo'" [valueInput]="element.tipoAtto?.label"></div>
</div>
<div class="row">
<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
	[labelInput]="'N. protocollo'" [valueInput]="element.numeroProtocollo"></div>
<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'date'"
	[labelInput]="'Data Protocollo'" [valueInput]="element.dataProtocollo"></div>
<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
	[labelInput]="'Provenienza'" [valueInput]="element.provenienza.label"></div>
</div>